import { useEffect, useState } from 'react';
import { useRange } from 'react-instantsearch';

import { Box } from '@/components/Box';
import type { RangeSliderProps } from '@/components/RangeSlider';
import { RangeSlider } from '@/components/RangeSlider';
import { useRouter } from '@/hooks/useRouter';

interface TypeDropdownProps extends RangeSliderProps {
  attribute: 'price';
}

const formatPrice = (price: any, defaultValue: number) =>
  isNaN(Number(price)) || price === '' ? defaultValue : Number(price);

export const RangeFilter = ({ attribute, ...props }: TypeDropdownProps) => {
  const { query } = useRouter();
  const { range, refine, start } = useRange({
    attribute,
  });
  const [selectedRange, setSelectedRange] = useState<[number, number]>([
    range.min!,
    range.max!,
  ]);
  useEffect(() => {
    refine(selectedRange);
  }, [selectedRange]);

  useEffect(() => {
    if (start) {
      setSelectedRange([
        formatPrice(start[0], range.min!),
        formatPrice(start[1], range.max!),
      ]);
    }
  }, [start]);

  useEffect(() => {
    if (!query.priceFrom && !query.priceTo) return;
    const [priceFrom, priceTo] = ['priceFrom', 'priceTo'].map((key) => {
      const value = query[key];
      return Array.isArray(value) ? value[0] : value || '';
    });
    setSelectedRange([
      formatPrice(priceFrom, range.min!),
      formatPrice(priceTo, range.max!),
    ]);
  }, []);

  return (
    <Box data-test-id='RangeFilterBox' padding={3} style={{ width: '100%' }}>
      <RangeSlider
        max={range.max}
        min={range.min}
        minDistance={10}
        onAfterChange={setSelectedRange}
        pearling
        value={selectedRange}
        {...props}
        data-test-id='RangeFilterRangeSlider'
      />
    </Box>
  );
};

RangeFilter.displayName = 'RangeFilter';
